import React from 'react'
import Error from '../../components/Error'
import { useSmsRedirect } from '../../hooks/useSmsRedirect';

const SmsRedirect = ({ queryParams }) => {
  const { error } = useSmsRedirect(queryParams);

  if (error) {
    return <Error message={error.message} />;
  }

  return null;
};

export default SmsRedirect;
